import type { IconDef } from '../types';

export const linkedin: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M3.31441 21H7.04804V8.98687H3.31441V21Z',
    },
    {
      d: 'M3 5.1663C3 6.34792 3.98253 7.3326 5.16157 7.3326C6.37991 7.3326 7.32314 6.38731 7.32314 5.1663C7.32314 3.98468 6.34061 3 5.16157 3C3.98253 3 3 3.98468 3 5.1663Z',
    },
    {
      d: 'M17.2664 21H21V14.4223C21 11.1926 20.2926 8.71116 16.5197 8.71116C14.7118 8.71116 13.4934 9.69584 12.9825 10.6411H12.9432V8.98687H9.36681V21H13.1004V15.0525C13.1004 13.5164 13.4148 11.9803 15.3406 11.9803C17.2271 11.9803 17.2664 13.7921 17.2664 15.1707V21Z',
    },
  ],
};
